const BADGE_CLASSES: Record<string, string> = {
  paid: 'bg-success-bg text-success-fg ring-success-ring',
  pending: 'bg-warning-bg text-warning-fg ring-warning-ring',
  denied: 'bg-danger-bg text-danger-fg ring-danger-ring',
};

const NEUTRAL_BADGE = 'bg-inactive-bg text-inactive-fg ring-inactive-ring';

/** Colour is never the only signal: the badge always carries the status word too (WCAG 1.4.1). */
export function statusBadgeClass(status: string | null): string {
  return BADGE_CLASSES[(status ?? '').toLowerCase()] ?? NEUTRAL_BADGE;
}
